import styled from "@emotion/styled";
import RejectContainer from "./../card-actions/reject/reject-container";
import ApproveContainer from "./../card-actions/approve/approve-container";
import { ButtonClickAnalyticsType } from "@kaltura/mediaspace-shared-types";

const StyledExploreActions = styled("div")(({ theme }) => ({
    display: "flex",
    gap: theme.spacing(1),
    width: "100%",
    "& .kaltura-ds-button": {
        flexGrow: 1,
    },
}));

export interface ExploreActionsProps {
    reloadMedia: () => void;
    approveUrl: string;
    rejectUrl: string;
    entryId: string;
    entryName: string;
    requestConfirmation: boolean;
    disabled: boolean;
}

const rejectAnalytics = {
    action: "Explore sidebar - Reject",
    buttonType: ButtonClickAnalyticsType.DELETE,
};

const approveAnalytics = {
    action: "Explore sidebar - Approve",
    buttonType: ButtonClickAnalyticsType.ADD,
};

export function ExploreActions({ approveUrl, rejectUrl, entryId, ...rest }: ExploreActionsProps) {
    return (
        <StyledExploreActions>
            <RejectContainer
                url={rejectUrl}
                forceLargeButton={true}
                noTextBreakpoint={"xs"}
                {...rest}
                entryIds={[entryId]}
                analytics={rejectAnalytics}
            />
            <ApproveContainer
                url={approveUrl}
                forceLargeButton={true}
                noTextBreakpoint={"xs"}
                {...rest}
                entryIds={[entryId]}
                analytics={approveAnalytics}
            />
        </StyledExploreActions>
    );
}

export default ExploreActions;
